<template>
  <div style="padding: 20px;">
    <div class="form-title">Mes apports nutritionnels moyens sur les 14 derniers jours</div>

    <LoaderView v-if="!data" />

    <div v-if="data">
      <!-- Tableau énergie foyer -->
      <NutritionApports
        v-if="householdEnergy"
        :data="householdEnergy"
      />

      <!-- Répartition macronutriments du foyer -->
      <ProteinGluciesLipidesBar
        v-if="macroFoyer"
        :protein="macroFoyer.protein"
        :glucides="macroFoyer.glucides"
        :lipides="macroFoyer.lipides"
      />

      <!-- Tableau des apports nutritionnels : une colonne par membre du foyer -->
      <NutritionTable
        :household="data.household.nutrients"
        :members="data.members"
      />
    </div>
  </div>
</template>

<script>
import LoaderView from '@/components/LoaderView.vue';
import NutritionApports from '@/components/NutritionApports.vue';
import NutritionTable from '@/components/NutritionTable.vue';
import ProteinGluciesLipidesBar from '@/components/ProteinGlucidesLipidesBar.vue';
import { api } from '@/api';

export default {
  name: 'Apports',
  components: {
    LoaderView,
    NutritionApports,
    NutritionTable,
    ProteinGluciesLipidesBar,
  },
  data() {
    return {
      data: null,
      householdEnergy: null,
    };
  },
  computed: {
    macroFoyer() {
      if (!this.data) return null;
      return (this.data.household.nutrients || []).find(
        (n) => n.name === 'protein_glucides_lipides'
      ) || null;
    },
  },
  created() {
    api.get('/nutrition-summary/').then(res => {
      this.data = res.data;
    });

    api.get('/household-energy/').then(res => {
      this.householdEnergy = res.data;
    });
  },
};
</script>
